import React from 'react'
import styles from './PopupBalance.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'

type Props = {
    onClose: () => void;
}

export function PopupBalance(props: Props) {
    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']} onSubmit={onSubmit}>
                <div className={styles['saving']}>
                    <Icon name='tree' />
                </div>
                <div>
                    <div className={styles['content']}>
                        <span className={styles['title']}>Withdraw total balance:</span>
                        <span className={styles['amount']}> $42424</span>
                        <span className={styles['description']}>Your Patrons' deposits will continue generating new earnings</span>
                    </div>
                </div>
                <div className={styles['button']}>
                    <Button size='l' type='border' stretch={false} onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button size='l' type='dark' onClick={() => { }}>
                        Withdraw
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

